import type { Locale } from "@tutor/protocol";
import { skillLabel as catalogueLabel } from "../insights/skill-labels";

/** The one place parent mode names a skill: the curriculum's title in the parent's locale. */
export function skillLabel(skillId: string, locale: Locale): string {
  return catalogueLabel(skillId, locale);
}
